import { useEffect, useState } from "react";

import { SchoolGuidsResponseProps } from "../../Redux/Redux.props";
import { AcademicSessionsAPIResponse } from "../AcademicSessions/AcademicSessions.props";
import { AdminService } from "../../services/helpers/api.services";

//Earlier, we used to keep this value in a flag. However, now the flag has been cleaned up and we keep the value here.
//Do we still need this value? For now, yes. Reason? As per Sara Shore:
// > "If there are still MyPath orgs that have not rolled over and do not plan to, we might want to confirm that their standards alignments and report will function without the new school year prior to removing the flag."
//For more context, please refer below chat threads:
// - https://imaginelearning.slack.com/archives/C01RS8Y28R3/p1749221634404359
// - https://imaginelearning.slack.com/archives/C02HZ7TEJNT/p1749452677139059
const SESSION_YEAR_BOUNDARY_FOR_STANDARDS_REPORT = 2025;

const useHasStandardsProficiencyReportAccess = (schoolData: SchoolGuidsResponseProps[]) => {
  const [hasStandardsReportAccess, setHasStandardsReportAccess] = useState(false);

  useEffect(() => {
    const loadAcademicSessions = async () => {
      try {
        const orgGUID = schoolData.length > 0 ? schoolData[0].organizationGuid || schoolData[0].orgGUID : "";
        if (!orgGUID) {
          return;
        }
        const { status, data } = await AdminService.getAcademicSessionsWithGUID({ guid: orgGUID });
        if (status !== 200) {
          setHasStandardsReportAccess(false);
          return;
        }

        const academicSessions: AcademicSessionsAPIResponse[] = await data.json();
        const isValid = isSessionYearValid(academicSessions, SESSION_YEAR_BOUNDARY_FOR_STANDARDS_REPORT);
        setHasStandardsReportAccess(isValid);
        return;
      } catch (error) {
        // do nothing.
      }
    };

    loadAcademicSessions();
  }, [schoolData]);

  return hasStandardsReportAccess;
};

const isSessionYearValid = (academicSessions: AcademicSessionsAPIResponse[], sessionYear: number) => {
  try {
    const sortedSessions = [...academicSessions].sort((a, b) => Number(a.schoolYear) < Number(b.schoolYear) ? 1 : -1);
    return sortedSessions.length > 0 && Number(sortedSessions[0].schoolYear) >= sessionYear;
  } catch (error) {
    // do nothing.
  }
}

export default useHasStandardsProficiencyReportAccess;